export enum Status {
  VALIDATED = 'VALIDATED',
  VALIDATION_PENDING = 'VALIDATION_PENDING',
  UNKNOWN = 'UNKNOWN'
}
